
const basic = ['customerId', 'name', 'gender', 'birthDate', 'phone', 'identityCardNumber', 'salesRep', 'nationality', 'type', 'maritalStatus', 'occupation', 'address', 'comment']
const ice = ['name', 'phoneNumber']
const rootFields = ['gender', 'nationality', 'type', 'maritalStatus']

function getPrintFields(extDataMapping, customerExtTab, printCustomerData) {
  const orderBase = 999
  const _customerExtTab = Object.keys(customerExtTab || {}).map(p => customerExtTab[p]).filter(i => i.active && !i.related)

  const newData = {
    basic: basic.map((i, index) => ({
      name: i,
      size: 1,
      active: true,
      id: i,
      roots: rootFields.includes(i),
      order: orderBase + index
    })),
    ice: ice.map((i, index) => ({
      name: i,
      size: 1,
      active: true,
      id: i,
      roots: rootFields.includes(i),
      order: orderBase + index
    })),
    ext: _customerExtTab.map( i => ({
      id: i.id,
      name: i.name,
      fields: extDataMapping[i.id] ? Object.keys(extDataMapping[i.id]).reduce((acc, cur) => {
        const curField = extDataMapping[i.id][cur]
        if (curField.active) {
          const insertFieldMapping = (curField.type === 'check' && curField.check !== 'none' ? extDataMapping[curField.check] : {})
          const insertField = Object.keys(insertFieldMapping).map(k => insertFieldMapping[k]).filter(i => i.active)
          let lastFieldIndex = acc.length > 0 ? acc[acc.length - 1].order : orderBase
          acc.push({
            ...curField,
            size: 1,
            active: true,
            ext: true,
            order: lastFieldIndex + 1
          })
          insertField.forEach(i => {
            let lastFieldIndex = acc.length > 0 ? acc[acc.length - 1].order : orderBase
            acc.push({
              ...i,
              size: 1,
              active: true,
              parent: curField.check,
              pId: curField.id,
              ext: true,
              order: lastFieldIndex + 1
            })
          })

        }
        return acc
      }, []) : []
    }))
  }
  // 根據 config.printCustomerData 裡的資料更新上面的欄位
  // 先把 config.printCustomerData 裡的資料轉為 mapping, 以利上面搜尋
  const printData = printCustomerData
  const extKeys = Object.keys(printData.ext ?? {})
  const dataMapping = {
    basic: (printData.basic ?? []).reduce((acc, cur, index) => {
      acc[cur.id] = { ...cur, order: index }
      return acc
    }, {}),
    ice: (printData.ice ?? []).reduce((acc, cur, index) => {
      acc[cur.id] = { ...cur, order: index }
      return acc
    }, {}),
    ext: extKeys.reduce((acc, cur) => {
      acc[cur] = printData.ext[cur].reduce((acc2, cur2, index) => {
        acc2[cur2.id] = { ...cur2, order: index }
        return acc2
      }, {})
      return acc
    }, {})
  }

  // 更新欄位, 並排序
  newData.basic.forEach(i => {
    i.size = dataMapping.basic[i.id]?.size ?? i.size
    i.active = dataMapping.basic[i.id]?.active ?? i.active
    i.order = dataMapping.basic[i.id]?.order ?? i.order
  })
  newData.basic.sort((a, b) => a.order - b.order)
  newData.ice.forEach(i => {
    i.size = dataMapping.ice[i.id]?.size ?? i.size
    i.active = dataMapping.ice[i.id]?.active ?? i.active
    i.order = dataMapping.ice[i.id]?.order ?? i.order
  })
  newData.ice.sort((a, b) => a.order - b.order)
  newData.ext.forEach(i => {
    i.fields.forEach(j => {
      j.size = dataMapping.ext[i.id]?.[j.id]?.size ?? j.size
      j.active = dataMapping.ext[i.id]?.[j.id]?.active ?? j.active
      j.order = dataMapping.ext[i.id]?.[j.id]?.order ?? j.order
    })
    i.fields.sort((a, b) => a.order - b.order)
  })
  // console.log(JSON.stringify(newData, null, 4))
  // console.log(JSON.stringify(dataMapping, null, 4))
  return newData
}

export {
  getPrintFields
}